export default (offer, informations) => ({
  nameOfProduct: offer?.name || informations?.nameOfProduct || "",
  description: offer?.description || informations?.description || "",
  location: offer?.location?.city || informations?.location || "default",
  category: offer?.category?.name || informations?.category || "default",
  subcategory: offer?.subcategory || informations?.subcategory || "default",
});
